(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["aloura-product-card"] && !Shopify.designMode) return;
  try {
    (() => {
  const rail = document.querySelector('[data-product-rail]');
  const prev = document.querySelector('[data-rail-prev]');
  const next = document.querySelector('[data-rail-next]');
  if (rail && prev && next) {
    const updateControls = () => {
      const max = Math.max(0, rail.scrollWidth - rail.clientWidth);
      prev.disabled = rail.scrollLeft <= 2;
      next.disabled = rail.scrollLeft >= max - 2;
      prev.setAttribute('aria-disabled', prev.disabled ? 'true' : 'false');
      next.setAttribute('aria-disabled', next.disabled ? 'true' : 'false');
    };
    let ticking = false;
    rail.addEventListener('scroll', () => {
      if (ticking) return;
      ticking = true;
      requestAnimationFrame(() => { updateControls(); ticking = false; });
    }, { passive: true });
    window.addEventListener('resize', updateControls, { passive: true });
    updateControls();
  }
  const promo = document.querySelector('.template-index .an-offer__code[data-copy-code="ALOURA10"], body.template-index .an-offer__code[data-copy-code="ALOURA10"]');
  if (promo) {
    const small = promo.querySelector('small');
    if (small) small.textContent = 'Appliquer −10 %';
    promo.setAttribute('aria-label', 'Appliquer la remise de 10 % ALOURA10 et voir les luminaires');
    promo.addEventListener('click', (event) => {
      event.preventDefault();
      event.stopImmediatePropagation();
      window.location.assign('/discount/ALOURA10?redirect=/collections/tous-les-luminaires');
    }, true);
  }
})();
  } catch(e) { console.error(e); }
})();

})();
